import {SERVER_BASE_URL, getCoordinates} from '@wix/wix-events-commons-statics'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useEnvironment, useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React, {useEffect, useState} from 'react'
import {getLanguage} from '../../../../../../commons/selectors/environment'
import {getInstance} from '../../../../../../commons/selectors/instance'
import {useAppActions, useAppSelector} from '../../../hooks/runtime'
import {useVisibilityStyles} from '../../../hooks/use-visibility-styles'
import {googleMapPolicyWarningVisible} from '../../../selectors/consent-policy'
import {getEvent} from '../../../selectors/event'
import {getStaticMapUrl as getStaticMapSelector} from '../../../selectors/static-map-url'
import sc from '../../classnames.scss'
import s from './map.scss'

export const Map = () => {
  const {
    allBreakpoints: {isMapVisible},
  } = useVisibilityStyles()
  const {t} = useTranslation()
  const {isMobile} = useEnvironment()
  const {getStaticMapUrl} = useAppActions()
  const [shouldMapLoad, setShouldMapLoad] = useState(false)

  const staticMapUrl = useAppSelector(getStaticMapSelector)
  const policyWarningVisible = useAppSelector(googleMapPolicyWarningVisible)
  const event = useAppSelector(getEvent)
  const language = useAppSelector(getLanguage)
  const instance = useAppSelector(getInstance)

  const coordinates = getCoordinates(event)
  const mapVisible = !!coordinates && isMapVisible()

  useEffect(() => {
    if (isMobile && mapVisible) {
      getStaticMapUrl(language)
    }

    setShouldMapLoad(true)
  }, [])

  return !mapVisible ? null : isMobile ? (
    <a
      href={`https://www.google.com/maps/search/?api=1&query=${coordinates.lat},${coordinates.lng}`}
      rel="noopener noreferrer"
      target="_blank"
    >
      <img
        id="event-details-page-map"
        data-hook={DH.MAP}
        src={staticMapUrl}
        className={s.staticMap}
        alt={t('eventLocationMap')}
        height={360}
        width={640}
      />
    </a>
  ) : policyWarningVisible ? (
    <span className={classNames(sc.evTextFont, sc.evTextColor)}>{t('googleMaps_consentPolicy_blocked')}</span>
  ) : (
    <div id="event-details-page-map" className={s.map} data-hook={DH.MAP}>
      {shouldMapLoad && (
        <iframe
          src={`${SERVER_BASE_URL}/html/google-map-v2?locale=${language}&lat=${coordinates.lat}&lng=${coordinates.lng}&instance=${instance}`}
          className={s.iframe}
          allowFullScreen
          title="Map"
          loading="lazy"
        />
      )}
    </div>
  )
}
